import "normalize.css";
import "./index.css";
import "./tailwind.css";
import reportWebVitals from "./reportWebVitals";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { renderChatBotWidget } from "./components/ChatBotWidget";

// Attach the render function to the window object
window.renderChatBotWidget = renderChatBotWidget;

const container = document.getElementById("root");
const root = createRoot(container);

const BACKEND_WARMUP_KEY = "backendLastPingAt";
const BACKEND_WARMUP_TTL_MS = 10 * 60 * 1000;
const CHATBOT_API_URL =
  process.env.REACT_APP_CHATBOT_API_URL ||
  "https://chatbot-widget88.azurewebsites.net";

// Ping the backend to warm up the server
const pingBackend = async () => {
  try {
    const lastPingAtRaw = sessionStorage.getItem(BACKEND_WARMUP_KEY);
    const lastPingAt = lastPingAtRaw ? Number(lastPingAtRaw) : 0;
    const shouldPingNow =
      !lastPingAt || Date.now() - lastPingAt > BACKEND_WARMUP_TTL_MS;

    if (shouldPingNow) {
      await fetch(`${CHATBOT_API_URL}/ping`);
      console.log("Backend warmed up successfully.");
      sessionStorage.setItem(BACKEND_WARMUP_KEY, String(Date.now()));
    }
  } catch (error) {
    console.error("Error pinging backend:", error);
  }
};

pingBackend();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals.console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
